(function ($) {
  $(document).ready(function () {
    var navbar = $('nav#header-navbar');
    var navbarMenu = navbar.find('#navigation');
    var siteHeader = $('.site-header');
    var buttonCloseNavi = $('button.close-sub');
    var buttonCloseDesktopSearch = $('button.header-search-desktop-close');
    var buttonToggleSearchMobile = $('button.header-search-icon-mobile');
    var buttonToggleSearchDesktop = $('button.header-search-icon-desktop');
    var searchWrapperMobile = $('.header-search-mobile');
    var searchWrapperDesktop = $('.header-search-desktop');
    var theBody = $('body');
    var header = $('header');
    var $window = $(window);
    var $document = $(document);
    var bodyPosition;

    //  functions
    var openSubNavi;
    var closeSubNavi;

    openSubNavi = function (element) {
      var subMenu = $(element).parent().find('ul');
      navbar.find('ul').removeClass('open');
      navbar.addClass('sub-open');
      subMenu.addClass('open');
      if (header.find('button.hamburger:visible').length > 0) {
        buttonCloseNavi.addClass('show');
      }
    };

    closeSubNavi = function (elem) {
      var sub;
      var element;
      element = elem || navbar.find('#navigation ul.sub.open>li.submenu-title>a');
      sub = element.closest('ul');
      if (navbar.hasClass('open')) {
        sub.removeClass('open');
        navbar.removeClass('sub-open');
      } else if (searchWrapperMobile.hasClass('show')) {
        searchWrapperMobile.toggleClass('show');
        buttonToggleSearchMobile.toggleClass('hidden');
        theBody.removeClass('noscroll');
        theBody.css({ top: 'unset' });
        $document.scrollTop(bodyPosition);
      }
      buttonCloseNavi.removeClass('show');
    };

    $window.on('scroll', function () {
      if ($(this).scrollTop() > 94) {
        header.addClass('scrolled');
        theBody.addClass('scrolled');
      } else {
        header.removeClass('scrolled');
        theBody.removeClass('scrolled');
      }
    });

    $('button.hamburger').click(function () {
      if (!theBody.hasClass('noscroll')) {
        bodyPosition = $document.scrollTop();
      }

      $(this).toggleClass('is-active');

      if ($(this).hasClass('is-active')) {
        theBody.addClass('noscroll');
        theBody.css({ top: -bodyPosition + 'px' });
        $document.scrollTop(bodyPosition);
      } else {
        theBody.removeClass('noscroll');
        theBody.css({ top: 'unset' });
        $document.scrollTop(bodyPosition);
      }

      if (!searchWrapperMobile.hasClass('show')) {
        navbar.toggleClass('open');
        if (navbar.hasClass('sub-open')) {
          navbar.removeClass('sub-open');
          $('.sub.open').removeClass('open');
          buttonCloseNavi.removeClass('show');
        }
      } else {
        searchWrapperMobile.removeClass('show');
        buttonToggleSearchMobile.removeClass('hidden');
        navbar.toggleClass('open');
        buttonCloseNavi.removeClass('show');
      }
    });

    if (header.find('button.hamburger:visible').length > 0) {
      navbar.find('#navigation>ul>li.menu-item>a').on('click', function (e) {
        //  If the Submenu does not exist dont prevent the click
        if ($(this).siblings().length < 1) {
          return;
        }

        e.preventDefault();
        openSubNavi($(this));
      });
    }

    buttonCloseNavi.on('click', function () {
      closeSubNavi();
    });

    // Header Search Functions
    buttonToggleSearchMobile.on('click', function () {
      // Hide the Search Icon and Show the Close Search Icon
      $(this).addClass('hidden');
      if (!theBody.hasClass('noscroll')) {
        bodyPosition = $document.scrollTop();
        theBody.css({ top: -bodyPosition + 'px' });
        $document.scrollTop(bodyPosition);
      }
      theBody.addClass('noscroll');

      buttonCloseNavi.addClass('show');
      searchWrapperMobile.addClass('show');
      if (navbar.hasClass('open')) {
        navbar.removeClass('open');
        siteHeader.find('button.hamburger').removeClass('is-active');
      }
    });

    // Open the Search Panel on Desktop
    buttonToggleSearchDesktop.on('click', function () {
      searchWrapperDesktop.toggleClass('show');
      $(this).toggleClass('hidden');
      navbarMenu.toggleClass('hidden');
      $(buttonCloseDesktopSearch).toggleClass('hidden');

      if (searchWrapperDesktop.hasClass('show')) {
        $('#header-search-input').focus();
      }
    });

    // Close the Search Panel on Desktop
    buttonCloseDesktopSearch.on('click', function () {
      $(this).toggleClass('hidden');
      navbarMenu.toggleClass('hidden');
      buttonToggleSearchDesktop.toggleClass('hidden');
      searchWrapperDesktop.toggleClass('show');
    });

    // Enable Navigation for Touch Devices that use Desktop Resolutions
    navbarMenu.on('touchstop', function (event) {
      if (
        $(event.target).parent().parent().find('.sub').length > 0
        && $(event.target).parent().parent().find('.sub.open').length === 0
      ) {
        navbar.find('.sub.open')
          .removeClass('open');
        $(event.target).parent().parent().find('.sub')
          .addClass('open');
        navbar.addClass('sub-open');

        if ($(window).innerWidth() < 992) {
          buttonCloseNavi.addClass('show');
        }

        event.preventDefault();
      }
    });
  });
}(jQuery));
